import { render, staticRenderFns } from "./outCampus.vue?vue&type=template&id=2d5a7a62&scoped=true&"
import script from "./outCampus.vue?vue&type=script&lang=ts&"
export * from "./outCampus.vue?vue&type=script&lang=ts&"
import style0 from "./outCampus.vue?vue&type=style&index=0&id=2d5a7a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5a7a62",
  null
  
)

export default component.exports